'use strict';

import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import { statisticsSelector } from '../../../../../reducers/statistics';
import { autoPlaySelector } from '../../../../../reducers/settings';
import EndScreen from './EndScreen.jsx';

const EndScreenContainer = (props) => {
    return <EndScreen {...props} />;
};

EndScreenContainer.propTypes = {
    nextVideoTitle: PropTypes.string,
    nextVideoUrl: PropTypes.string,
    nextVideoPosterImage: PropTypes.string,
    isKidsGenre: PropTypes.bool,
    onDisplayEndScreen: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        statistics: statisticsSelector(state),
        autoPlaySetting: autoPlaySelector(state),
    };
};

export default connect(mapStateToProps)(EndScreenContainer);
